module.exports = __webpack_public_path__ + "img/icon_agency.9ce15028.svg";